export default "__VITE_ASSET__CPzPUTdB__"